/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Button from '../button';
import Drawer from './style';

const FooterDrawer = ({ primaryBtnData, secondaryBtnData, moreButtonData }) => {
  if (moreButtonData) return moreButtonData;
  return (
    <>
      {secondaryBtnData && (
        <Button {...secondaryBtnData} minWidth={176}>
          {secondaryBtnData?.text}
        </Button>
      )}
      <Button {...primaryBtnData} minWidth={176}>
        {primaryBtnData?.text}
      </Button>
    </>
  );
};

const Index = (props) => {
  const { children, footer = false } = props;
  return (
    <Drawer {...props} footer={footer ? FooterDrawer(footer) : false}>
      {children}
    </Drawer>
  );
};

export default Index;
